export default {
  nameIsRequired: '名称为必填项',
  emailIsRequired: '电子邮件是必需的',
  passwordIsRequired: '密码是必需的',
  emailOrPhoneAreRequired: '插入电子邮件或电话',
  onlyNumbers: '电话字段中只允许数字',
  passwordMin8: '密码必须至少包含 8 个字符',
  habeasData: '您必须接受条款和条件协议',
  validEmail: '插入有效电子邮件',
  validPhone: '插入有效的电话',
  codeIsRequired: '发送的代码是必需的',
  newPasswordIsRequired: '需要新密码',
  confirmNewPassword: '您必须确认您的新密码',
  passwordsDontMatch: '密码不匹配',
  fillCorrectlyFormFields: '正确填写所有表单字段'
}
